"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("isomorphic-fetch");
function MatchlibClient({ url }) {
    let batch = [];
    async function requestBatch(obj) {
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(obj),
        });
        if (res.status !== 200) {
            return Promise.reject(new Error(`Unexpected status code: ${res.status}`));
        }
        return await res.json();
    }
    function request(input) {
        const promise = new Promise((resolve, reject) => {
            batch.push({ input, resolve, reject });
        });
        setTimeout(async () => {
            while (batch.length > 0) {
                const currBatch = batch;
                batch = [];
                let results;
                try {
                    results = await requestBatch(currBatch.map(item => item.input));
                }
                catch (err) {
                    currBatch.forEach(batchItem => batchItem.reject(err));
                    return;
                }
                for (let i = 0; i < results.length; i++) {
                    currBatch[i].resolve(results[i]);
                }
                batch.push(...currBatch.slice(results.length));
            }
        });
        return promise;
    }
    async function Ratings({ W }) {
        return await request({
            method: 'Ratings',
            args: [{ W }],
        });
    }
    async function PairValues({ W, x }) {
        return await request({
            method: 'PairValues',
            args: [{ W, x }],
        });
    }
    return { Ratings, PairValues };
}
exports.default = MatchlibClient;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/matchlib-lambda-client/dist/index.js
// module id = 131
// module chunks = 0